import { useFormContext } from "react-hook-form";
import { RequestOrderFormFieldValues } from "./RequestOrderArrears";


export function useRequestOrderFormContext() {
  return useFormContext<RequestOrderFormFieldValues>();
}
